<div>
  <meta name="viewport" content="width=device-width, minimum-scale=1" />
  <div #paymentForm id="payment-form"></div>
</div>
